import {createContext, type FC, type PropsWithChildren, type RefObject, useContext, useRef, useState} from "react";

type GlobalContextType = {
    isActive: boolean;
    toggle: () => void,
    panelRef: RefObject<HTMLDivElement | null>;
    listRef: RefObject<HTMLOListElement | null>;
    openPanel:()=>void,
    closePanel:()=>void,
};

const InstantSearchUIContext = createContext<GlobalContextType | undefined>(undefined);
const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
];
export const InstantSearchUIProvider: FC<PropsWithChildren> = ({children}) => {
    const [isActive, setIsActive] = useState(false);
    const panelRef = useRef<HTMLDivElement | null>(null);
    const listRef = useRef<HTMLOListElement | null>(null);
    const toggle = () => {
        setIsActive((prev) => !prev);
    }
    const openPanel=()=>{
        setIsActive(true);
        if(panelRef.current){
            const firstFocusable =   panelRef.current?.querySelector<HTMLElement>(focusableSelectors.join(', '));
            if (firstFocusable) {
                firstFocusable?.focus({ preventScroll: true });
            }else{
                panelRef.current?.focus({ preventScroll: true });
            }
        }
    }
    const closePanel=()=>{
        setIsActive(false);
        if(listRef.current){
            listRef.current?.focus({ preventScroll: true });
        }
    }
    return (
        <InstantSearchUIContext.Provider value={{isActive, toggle, panelRef,openPanel,closePanel,listRef}}>
            {children}
        </InstantSearchUIContext.Provider>
    );
};

export const useInstantSearchUIContext = () => {
    const context = useContext(InstantSearchUIContext);
    if (!context) throw new Error("useInstantSearchUIContext must be used within a InstantSearchUIProvider");
    return context;
};
